module.exports = __webpack_public_path__ + "img/instrame_cn.e1baec7e.png";